import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ChatBoxConfirmationDialog } from './ChatBoxConfirmationDialog';
import { MinimizeFAB } from './MinimizeFAB';
import { ChatBoxHeader } from './ChatBoxHeader';
import { useLineOfBusiness } from '../hooks/useLineOfBusiness';
import { LineOfBusinessesBrandingColors } from '../constants/lineOfBusinessesBrandingColors';
import { green157 } from '@spotify-internal/encore-foundation';
const PositionContainer = styled.div `
  position: fixed;
  width: 26rem;
  z-index: 9999;
  transform: translate3d(0, 0, 0);
  height: 44rem;
  min-height: 10rem;
  max-height: calc(min(95vh, 100vh - var(--pt-chatbox-bottom)));
  bottom: var(--pt-chatbox-bottom);
  right: var(--pt-chatbox-right);

  @media screen and (max-width: 768px) {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: unset;
    height: unset;
    max-height: unset;
  }
`;
const ChatboxGrid = styled.div `
  display: grid;
  grid-template-rows: 5.5rem 1fr 4rem;
  overflow: hidden;
  height: 100%;
  background: #fff;
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.2);
  border-radius: 0.5rem;

  @media screen and (max-width: 768px) {
    border-radius: unset;
  }
`;
export const ChatboxFrame = ({ children, onDialogSubmit, dialogState, onMinimizeChange, notificationCount, onCloseClick, }) => {
    var _a, _b, _c, _d, _e;
    const { t } = useTranslation();
    const [minimized, setMinimized] = useState(false);
    const setMinimizedCb = useCallback((isMinimized) => {
        setMinimized(isMinimized);
        if (minimized !== isMinimized)
            onMinimizeChange(isMinimized);
    }, [minimized, onMinimizeChange]);
    const { lineOfBusiness } = useLineOfBusiness();
    const headerBackgroundColor = ((_a = LineOfBusinessesBrandingColors[lineOfBusiness]) === null || _a === void 0 ? void 0 : _a.headerBackgroundColor) ||
        green157;
    const headerColor = ((_b = LineOfBusinessesBrandingColors[lineOfBusiness]) === null || _b === void 0 ? void 0 : _b.headerColor) || '#fff';
    const fabBackgroundColor = ((_c = LineOfBusinessesBrandingColors[lineOfBusiness]) === null || _c === void 0 ? void 0 : _c.fabBackgroundColor) ||
        green157;
    const fabColor = ((_d = LineOfBusinessesBrandingColors[lineOfBusiness]) === null || _d === void 0 ? void 0 : _d.fabColor) || '#fff';
    const buttonHoverColor = ((_e = LineOfBusinessesBrandingColors[lineOfBusiness]) === null || _e === void 0 ? void 0 : _e.buttonHoverColor) ||
        green157;
    return (React.createElement(React.Fragment, null,
        React.createElement(PositionContainer, { style: { display: minimized ? 'none' : 'block' } },
            React.createElement(ChatboxGrid, null,
                React.createElement(ChatBoxHeader, { notifications: notificationCount, onClose: onCloseClick, onMinimizeClicked: () => setMinimizedCb(true), backgroundColor: headerBackgroundColor, logoColor: headerColor, titleColor: headerColor, controlColor: headerColor }),
                children),
            React.createElement(ChatBoxConfirmationDialog, { title: t('ARE_YOU_SURE_TO_END_CONVERSATION_TEXT'), declineLabel: t('CONTINUE_CONVERSATION_TEXT'), confirmLabel: t('CLOSE_TEXT'), onSubmit: response => onDialogSubmit(response === 'confirm'), isOpen: dialogState === 'open', hoverColor: buttonHoverColor })),
        React.createElement(MinimizeFAB, { minimized: minimized, notifications: notificationCount, onClick: () => setMinimizedCb(!minimized), backgroundColor: fabBackgroundColor, color: fabColor })));
};
//# sourceMappingURL=ChatboxFrame.js.map